import React, { useState } from "react";
import RSelect, { components as SelectComponents } from "react-select";
import { customStyles, customTheme } from "./styles";

// add menuPortalTarget for fixing dropdown overlap issues. Details: https://github.com/JedWatson/react-select/issues/3263#issuecomment-604237097
// add menuShouldBlockScroll for fixing dropdown menu not following scroll event. Details: https://github.com/JedWatson/react-select/issues/3734
const Select = ({ showError, ...props }) => {
  return <RSelect theme={customTheme} styles={{ ...customStyles(showError) }} {...props} showError />;
};

const Input = (props) => <SelectComponents.Input {...props} isHidden={false} />;

const EditableSelect = (props) => {
  const [value, setValue] = useState(props.value);
  const [inputValue, setInputValue] = useState(props.value?.label);

  const onInputChange = (onChangeValue, { action }) => {
    if (action === "input-change") {
      if (props.onInputChange) {
        props.onInputChange(onChangeValue);
      }
      setInputValue(onChangeValue);
      if (onChangeValue === "") {
        setValue({});
        props.onChange({});
      }
    }
  };

  const onChange = (option) => {
    props.onChange(option);
    setValue(option);
    setInputValue(option ? option.label : "");
  };

  return (
    <RSelect
      key={props.placeholder}
      options={props.options}
      value={value}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onChange={onChange}
      theme={customTheme}
      styles={customStyles()}
      components={{
        Input,
      }}
    />
  );
};

export { Select, SelectComponents, EditableSelect };
